import React, { useState, useEffect } from "react";
import styled from "styled-components";

const PopupContainer = styled.div`
  position: absolute;
  z-index: 10;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  padding: 12px;
  min-width: 220px;
  pointer-events: auto;
`;

const PlaceholderMarker = styled.div`
  position: absolute;
  left: ${(props) => props.x - 6}px;
  top: ${(props) => props.y - 6}px;
  width: 12px;
  height: 12px;
  background: #999;
  border: 2px solid white;
  border-radius: 50%;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  z-index: 5;
`;

const Input = styled.input`
  width: 100%;
  margin-bottom: 8px;
  padding: 4px;
  box-sizing: border-box;
`;

const Select = styled.select`
  width: 100%;
  margin-bottom: 8px;
  padding: 4px;
`;

const Button = styled.button`
  width: 100%;
  padding: 4px;
  background: #005fcc;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background: #004999;
  }
`;

const NewRunPopup = ({
  selectedResortId,
  position,
  onClose,
  setResortRuns,
}) => {
  const [name, setName] = useState("");
  const [type, setType] = useState("green");

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  const handleSubmit = async () => {
    if (name) {
      const newRun = {
        id: Date.now().toString(),
        name,
        type: type === "lift" ? "lift" : "run",
        difficulty: type === "lift" ? null : type,
        coordinates: [position.lng, position.lat],
      };
      await handleRunAdded(selectedResortId, newRun, setResortRuns);
      onClose();
    }
  };

  return (
    <>
      <PlaceholderMarker x={position.x} y={position.y} />
      <PopupContainer style={{ left: position.x - 180, top: position.y + 16 }}>
        <Input
          type="text"
          placeholder="Run/Lift name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <Select value={type} onChange={(e) => setType(e.target.value)}>
          <option value="green">Green</option>
          <option value="blue">Blue</option>
          <option value="orange">Terrain park</option>
          <option value="black">Black</option>
          <option value="lift">Lift</option>
        </Select>
        <Button onClick={handleSubmit}>Save</Button>
        <Button
          style={{
            marginTop: 8,
            background: "#eee",
            color: "#333",
          }}
          onClick={onClose}
        >
          Cancel
        </Button>
      </PopupContainer>
    </>
  );
};

const handleRunAdded = async (selectedResortId, newRun, setResortRuns) => {
  try {
    const response = await fetch(`/api/resort/${selectedResortId}/runs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newRun),
    });
    if (response.ok) {
      const updatedRuns = await response.json();
      setResortRuns(updatedRuns);
    }
  } catch (err) {
    console.error("Failed to save run:", err);
  }
};

export default NewRunPopup;
